import { Input, InputProps } from '@chakra-ui/react';
import { NumericFormat } from 'react-number-format';

type Props = { value: number; onChange: (value: number) => void } & Omit<InputProps, 'value' | 'onChange'>;

export default function MoneyInput({ value, onChange, ...rest }: Props) {
  return (
    <NumericFormat
      customInput={Input}
      value={value}
      prefix="R$ "
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale
      allowNegative={false}
      inputMode="numeric"
      onValueChange={(v) => onChange(v.floatValue ?? 0)}
      {...(rest as any)}
    />
  );
}
